module.exports = __webpack_public_path__ + "img/xueShan5.9c4d293d.png";